import fasAether1 from "./fas-aether (1).webp";
import fasAether2 from "./fas-aether (2).webp";
import fasAether3 from "./fas-aether (3).webp";
import fasAether4 from "./fas-aether (4).webp";
import fasAether5 from "./fas-aether (5).webp";

const fasaether = [fasAether1, fasAether2, fasAether3, fasAether4, fasAether5];

export default fasaether;
